import { Link } from 'react-router-dom'
import { SignedIn, SignedOut, UserButton } from '@clerk/clerk-react'

export default function Header() {
  return (
    <header className="flex items-center justify-between py-8 pb-4">
      <Link to="/" className="flex items-center gap-3 font-bold text-lg tracking-tight">
        <div className="flex items-center justify-center w-9 h-9 rounded-xl bg-[#1f2330] text-surface text-[1.05rem]">
          BR
        </div>
        BankStatementReader
      </Link>

      <nav className="flex items-center gap-10 text-ink-soft text-[0.95rem]">
        <Link to="/tools" className="hover:text-ink transition">Free Tools</Link>
        <a href="/#features" className="hover:text-ink transition">Features</a>
        <a href="/#pricing" className="hover:text-ink transition">Pricing</a>
        <a href="/blog" className="hover:text-ink transition">Blog</a>

        <div className="flex items-center gap-4">
          <SignedOut>
            <Link
              to="/sign-in"
              className="px-6 py-2.5 rounded-full bg-surface-muted text-ink font-semibold hover:bg-gray-200 transition"
            >
              Log in
            </Link>
            <Link
              to="/demo"
              className="px-6 py-2.5 rounded-full bg-accent text-[#06301c] font-semibold shadow-[0_14px_32px_-18px_rgba(20,154,62,0.8)] hover:bg-accent-dark hover:text-white hover:-translate-y-0.5 transition"
            >
              Live Demo
            </Link>
          </SignedOut>

          <SignedIn>
            <Link
              to="/dashboard"
              className="px-4 py-2 text-gray-700 hover:text-gray-900 transition"
            >
              Dashboard
            </Link>
            <UserButton />
          </SignedIn>
        </div>
      </nav>
    </header>
  )
}
